export const JWT_TOKEN = 'JwtToken';
export const JWT_REFRESH_TOKEN = 'JwtRefreshToken';
export const REFRESH_TOKEN_CONST = 'RefreshToken';
export const URL_PARAMS = 'Params';
export const FP = 'Fingerprint';
// Register Forms
export const ACCOUNT_TYPE_FORM = 'AccountTypeForm';
export const ADDRESS_INFORMATION_FORM = 'AddressInformationForm';
export const AMMOUNT_FORM = 'AmountForm';
export const CUSTODIAN_INFORMATION_FORM = 'CustodianInformationForm';
export const TRANSFER_METHOD_FORM = 'TransferMethodForm';
export const ROLLOVER_FORM = 'RolloverForm';
export const SETUP_FORM = 'SetupForm';
export const AUTHORIZED_AGENT_INFORMATION_FORM =
  'AuthorizedAgentInformationForm';
export const IRA_COMMON_OWNERSHIP_INFORMATION_FORM =
  'IraCommonOwnershipInformationForm';
export const IRA_LESS_COMMON_OWNERSHIP_INFORMATION_FORM =
  'IraLessCommonOwnershipInformationForm';
export const LEGAL_ENTITY_INFORMATION_FORM = 'LegalEntityInformationForm';
export const MINOR_INFORMATION_FORM = 'MinorInformationForm';
export const OWNERSHIP_INFORMATION_FORM = 'OwnershipInformationForm';
export const SECONDARY_OWNERSHIP_INFORMATION_FORM =
  'SecondaryOwnershipInformationForm';
